/**
 * @generated SignedSource<<cf40ef685bea70b96a1184e17d24b804>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FeedTab_brand$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"CDPAudienceFilters_brand" | "FeedTabTable_refetchableBrand">;
  readonly " $fragmentType": "FeedTab_brand";
};
export type FeedTab_brand$key = {
  readonly " $data"?: FeedTab_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"FeedTab_brand">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FeedTab_brand",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FeedTabTable_refetchableBrand"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CDPAudienceFilters_brand"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};

(node as any).hash = "1deb23511270937397e0d2b58419659b";

export default node;
